import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { get, isEmpty, isNil } from 'lodash';
import { toast } from 'react-toastify';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import messages from 'containers/RecapPage/messages';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import NavigationButtons from 'components/navigationButtons';
import { Dialog } from 'containers/CourtManagerAssignedClaims/styled-components';
import ClaimInformation from 'containers/PreOpeningPage/ClaimInformation';
import ClaimCircumstances from 'containers/PreOpeningPage/ClaimCircumstances';
import ClaimDeclaration from 'containers/PreOpeningPage/ClaimDeclaration';
import VictimCard from 'containers/PreOpeningPage/VictimCard';
import UploadDocumentsBloc from 'containers/RecapPage/uploadDocumentsBloc';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog/index';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import {
  makeSelectListings,
  makeSelectListingsIntervenants,
  makeSelectNotification,
} from 'containers/AppContainer/selectors';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import {
  findInfoSagisByRegistrationNumber,
  isMixedClaim,
} from 'containers/RecapManagerPage/utils';
import {
  requestAssigment,
  requestCorporealLawyers,
} from 'containers/RecapManagerPage/actions';
import {
  EMPTY_CLAIM_TO_PREOPEN,
  LISTINGS,
  EMPTY_DOCUMENT,
  DOCUMENT,
  CLAIM_STATUS,
} from 'containers/data-structure';
import CostsDialog from 'containers/RecapPage/costsDialog';
import {
  setDocumentId,
  uploadDocument,
} from 'containers/UploadDocuments/actions';
import { makeSelectDocument } from 'containers/UploadDocuments/selectors';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import { makeSelecClaimToPreopen } from 'containers/PreOpeningPage/selectors';
import Stepper from 'containers/AppContainer/Stepper';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  requestPreopenClaim,
  requestOpenClaimManager,
  requestOpenClaimGpo,
  requestMigrateClaim,
  requestCompleteClaim,
  requestValidateCompleteClaim,
} from 'containers/RecapPage/actions';
import { resetPreopenClaim } from 'containers/PreOpeningPage/actions';

import SuccessDialog from 'components/SuccessDialog';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import GATracking from 'components/GATracking/index';
import { resetUploadDocumentStore } from 'containers/UploadDocuments/actions';
import OpposingPartyRecapContainer from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecapContainer';
import FraudeInformation from 'containers/PreOpeningPage/fraude';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import {
  formatClaimToOpen,
  getClaimDossier,
  formatClaimToOpenGpo,
  renderDescriptionDialog,
  formatClaimToPreOpenCourtManager,
  constructHomePath,
  formatClaimToComplete,
  formatClaimToCompleteAndValidation,
} from 'containers/RecapPage/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { requestNotificationOpeningManagerMixedClaim } from 'containers/AppContainer/actions';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import { resolveSagisClaim } from 'helpers/utils';
import {
  HOLDER_PV_LAWYER,
  HOLDER_PV_OTHER,
  HOLDER_PV_PROVIDER,
} from 'containers/RecapPage/canstants';
import ServiceProviderDialog from 'containers/RecapPage/ServiceProviderDialog';
import { StyledDiv } from 'containers/RecapPage/styles';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { OPENING_STATE, OPENING_TYPE } from 'services/constants';
export interface RecapPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestPreopenClaim: Function;
  policyInfo: { sagis: {} };
  resetPreopenClaim: Function;
  resetUploadDocumentStore: Function;
  corporealLawyers: any;
  requestCorporealLawyers: any;
  requestOpenClaimManager: Function;
  notification: any;
  requestNotificationOpeningManagerMixedClaim: Function;
  requestAssigment: Function;
  openedClaim: any;
  intervenants: any;
  uploadDocument: Function;
  resetUploadedDocument: Function;
  uploadedDocument: IUploadedDocument;
  requestOpenClaimGpo: Function;
  setDocumentId: Function;
  requestMigrateClaim: Function;
  requestGetDocByDocumentumId: Function;
  requestCompleteClaim: Function;
  requestValidateCompleteClaim: Function;
}

const RecapPage: React.FC<RecapPageProps> = (props): JSX.Element => {
  const isPreOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISPREOPENMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isUsageOpening =
    featureService.hasFeature(FEATURES.OPENING_BY_USAGE) &&
    isPreOpeningManager &&
    get(props, 'location.state.isUsageOpening', false);
  const isValidatedClaim =
    get(props.storedClaimToPreopen, 'claim.status', null) ===
    CLAIM_STATUS.VALIDATED;

  React.useEffect(() => {
    if (isEmpty(props.storedClaimToPreopen) && !isPreopenSuccessDialogOn) {
      constructHomePath(isOpeningManager, isPreOpeningManager, isCourtManager);
    }
  });
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [
    isPreopenSuccessDialogOn,
    setIsPreopenSuccessDialogOn,
  ] = React.useState<boolean>(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = React.useState<
    boolean
  >(false);
  const [openProviderService, setOpenProviderService] = React.useState<boolean>(
    false,
  );
  const [openCostsDialog, setOpenCostsDialog] = React.useState<boolean>(false);
  const [documentCosts, setDocumentCosts] = React.useState<any>({
    ...EMPTY_DOCUMENT,
    [DOCUMENT.IS_INDEXED]: false,
    [DOCUMENT.IS_VISIBLE]: true,
  });
  const [decisionCosts, setDecisionCosts] = React.useState<any>(null);
  const [cost, setCost] = React.useState<any>({
    document: {
      ...EMPTY_DOCUMENT,
      [DOCUMENT.IS_INDEXED]: false,
      [DOCUMENT.IS_VISIBLE]: true,
    },
  });

  const priorityReasonClaimId = useSelector((state: any) =>
    get(state.toJS(), [
      'recap',
      'storedClaimToPreopen',
      'claim',
      'priorityReasonId',
    ]),
  );

  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [
    invoiceAdditionnelFeesDocument,
    setInvoiceAdditionnelFeesDocument,
  ] = React.useState({});
  const [
    invoiceNumberAdditionnelFees,
    setInvoiceNumberAdditionnelFees,
  ] = React.useState(null);
  const [
    invoiceDateAdditionnelFees,
    setInvoiceDateAdditionnelFees,
  ] = React.useState(null);

  const [providerTo, setProviderTo] = React.useState(null);
  const [pvHolderType, setPvHolderType] = React.useState(null);
  const [otherPvHolder, setOtherPvHolder] = React.useState(null);
  const [firmReferenceLawyer, setFirmReferenceLawyer] = React.useState(null);
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [receptionDate, setReceptionDate] = React.useState(null);

  const [invoiceReceptionDate, setInvoiceReceptionDate] = React.useState(
    isPreOpeningManager && pvHolderType === HOLDER_PV_PROVIDER
      ? receptionDate
      : null,
  );
  const [
    invoiceReceptionDateAdditionnelFees,
    setInvoiceReceptionDateAdditionnelFees,
  ] = React.useState(
    isPreOpeningManager && pvHolderType === HOLDER_PV_PROVIDER
      ? receptionDate
      : null,
  );
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);

  const [completionDate, setCompletionDate] = React.useState(null);

  const [
    preOpenConfirmationDialog,
    setPreOpenConfirmationDialog,
  ] = React.useState<boolean>(false);
  const [isAssignmentDialogOpen, setIsAssignmentDialogOpen] = React.useState<
    boolean
  >(false);

  const handleCloseAssignmentDialog = () => {
    setIsAssignmentDialogOpen(false);
    pushTo(PAGES.MANAGER_HOME)();
  };

  const handleCloseProvider = () => {
    setOpenProviderService(false);
  };

  const doNotGenerateFeeNote = () => {
    if (get(props, 'location.state.judicialProcedureId')) {
      return pushTo(PAGES.JUDICIARY_PROCESS, {
        victims: get(formattedClaimToOpen, 'victims', []),
        vehicules: get(formattedClaimToOpen, 'vehicules', []),
        procedureNatureId: get(props, 'location.state.procedureNatureId'),
        procedureType: get(props, 'location.state.procedureType'),
        judicialProcedureId: get(props, 'location.state.judicialProcedureId'),
        claimToPreOpen: getClaimDossier(
          {
            ...props,
            isPreOpeningManager: isPreOpeningManager,
            invoiceInfoAdditionelFees: {
              invoiceNumber: invoiceNumberAdditionnelFees,
              invoiceDate:
                invoiceDateAdditionnelFees === 'Invalid date'
                  ? null
                  : invoiceDateAdditionnelFees,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDateAdditionnelFees
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceAdditionnelFeesDocument,
            },
          } as any,
          false,
          priorityReasonClaimId,
        ),
      })();
    }
    props.requestPreopenClaim(
      getClaimDossier(
        {
          ...props,
          isPreOpeningManager: isPreOpeningManager,
          invoiceInfoAdditionelFees: {
            invoiceNumber: invoiceNumberAdditionnelFees,
            invoiceDate:
              invoiceDateAdditionnelFees === 'Invalid date'
                ? null
                : invoiceDateAdditionnelFees,
            invoiceReceptionDate: isPreOpeningManager
              ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                ? moment().format('YYYY-MM-DD')
                : invoiceReceptionDateAdditionnelFees
              : moment().format('YYYY-MM-DD'),
            isIndexed: false,
            ...invoiceAdditionnelFeesDocument,
          },
        } as any,
        false,
        priorityReasonClaimId,
      ),
      cleanState,
    );
  };

  const failCallBackOpenClaimGpo = () => {
    toast.success(translate(messages.failCallBackMessage, props));
    props.resetPreopenClaim(EMPTY_CLAIM_TO_PREOPEN);
    props.resetUploadDocumentStore();
    pushTo(PAGES.PREOPEN_MANAGER_HOME)();
  };

  const preOpenClaimManager = () => {
    if (
      get(props.storedClaimToPreopen, 'claim.openingState', null) ===
        OPENING_STATE.NOT_COMPLETED &&
      get(props.storedClaimToPreopen, 'claim.openingType', null) ===
        OPENING_TYPE.USAGE &&
      pvHolderType === HOLDER_PV_LAWYER &&
      !isNil(pvHolderType)
    ) {
      props.requestCompleteClaim(
        formatClaimToComplete(
          {
            ...props,
            isPreOpeningManager: isPreOpeningManager,
            providerTo: providerTo,
            receptionDate: receptionDate,
            completionDate: completionDate,
            pvHolderType: pvHolderType,
            isUsageOpening,
            otherPvHolder: otherPvHolder,
            firmReferenceLawyer: firmReferenceLawyer,
            cost: cost,
            invoiceInfo: {
              invoiceNumber: invoiceNumber,
              invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDate === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDate
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceDocument,
            },
            invoiceInfoAdditionelFees: {
              invoiceNumber: invoiceNumberAdditionnelFees,
              invoiceDate:
                invoiceDateAdditionnelFees === 'Invalid date'
                  ? null
                  : invoiceDateAdditionnelFees,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDateAdditionnelFees
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceAdditionnelFeesDocument,
            },
          },
          priorityReasonClaimId,
        ),
        cleanState,
      );
    } else if (
      get(props.storedClaimToPreopen, 'claim.openingState', null) ===
        OPENING_STATE.NOT_COMPLETED &&
      get(props.storedClaimToPreopen, 'claim.openingType', null) ===
        OPENING_TYPE.USAGE &&
      pvHolderType != HOLDER_PV_LAWYER &&
      !isNil(pvHolderType)
    ) {
      props.requestValidateCompleteClaim(
        formatClaimToCompleteAndValidation(
          {
            ...props,
            isPreOpeningManager: isPreOpeningManager,
            providerTo: providerTo,
            receptionDate: receptionDate,
            completionDate: completionDate,
            pvHolderType: pvHolderType,
            isUsageOpening,
            otherPvHolder: otherPvHolder,
            firmReferenceLawyer: firmReferenceLawyer,
            cost: cost,
            invoiceInfo: {
              invoiceNumber: invoiceNumber,
              invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDate === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDate
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceDocument,
            },
            invoiceInfoAdditionelFees: {
              invoiceNumber: invoiceNumberAdditionnelFees,
              invoiceDate:
                invoiceDateAdditionnelFees === 'Invalid date'
                  ? null
                  : invoiceDateAdditionnelFees,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDateAdditionnelFees
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceAdditionnelFeesDocument,
            },
          },
          priorityReasonClaimId,
        ),
        cleanState,
      );
    } else if (pvHolderType != HOLDER_PV_LAWYER && !isNil(pvHolderType)) {
      const mixedClaim = findInfoSagisByRegistrationNumber(
        (props.policyInfo as unknown) as {
          sagis: {
            claims: {
              code: string;
            }[];
          };
        },
        props.storedClaimToPreopen,
      );
      mixedClaim && isMixedClaim(mixedClaim);

      const invoiceInfo = {
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
        invoiceReceptionDate: isPreOpeningManager
          ? invoiceReceptionDate === 'Invalid date'
            ? null
            : invoiceReceptionDate
          : moment().format('YYYY-MM-DD'),
        isIndexed: false,
        ...invoiceDocument,
      };
      const invoiceInfoAdditionelFees = {
        invoiceNumber: invoiceNumberAdditionnelFees,
        invoiceDate:
          invoiceDateAdditionnelFees === 'Invalid date'
            ? null
            : invoiceDateAdditionnelFees,
        invoiceReceptionDate: isPreOpeningManager
          ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
            ? moment().format('YYYY-MM-DD')
            : invoiceReceptionDateAdditionnelFees
          : moment().format('YYYY-MM-DD'),
        isIndexed: false,
        ...invoiceAdditionnelFeesDocument,
      };
      props.requestOpenClaimGpo(
        formatClaimToOpenGpo(
          props.storedClaimToPreopen,
          pvHolderType,
          firmReferenceLawyer,
          completionDate,
          receptionDate,
          otherPvHolder,
          providerTo,
          invoiceInfo,
          invoiceInfoAdditionelFees,
          isMixedClaim(mixedClaim)
            ? mixedClaim
            : get(props.policyInfo, 'sagis.claims[0]', {}),
          props.listings,
          get(props.storedClaimToPreopen, 'claim.suspicious'),
          props.policyInfo,
          isMixedClaim(mixedClaim),
          cost,
          priorityReasonClaimId,
        ),
        cleanStateGpo,
        failCallBackOpenClaimGpo,
      );
    } else {
      props.requestPreopenClaim(
        getClaimDossier(
          {
            ...props,
            isPreOpeningManager: isPreOpeningManager,
            providerTo: providerTo,
            receptionDate: receptionDate,
            completionDate: completionDate,
            pvHolderType: pvHolderType,
            isUsageOpening,
            otherPvHolder: otherPvHolder,
            firmReferenceLawyer: firmReferenceLawyer,
            cost: cost,
            invoiceInfo: {
              invoiceNumber: invoiceNumber,
              invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDate === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDate
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceDocument,
            },
            invoiceInfoAdditionelFees: {
              invoiceNumber: invoiceNumberAdditionnelFees,
              invoiceDate:
                invoiceDateAdditionnelFees === 'Invalid date'
                  ? null
                  : invoiceDateAdditionnelFees,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDateAdditionnelFees
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceAdditionnelFeesDocument,
            },
          } as any,
          false,
          priorityReasonClaimId,
        ),
        cleanStateGpo,
      );
    }
  };

  const handlePreopenClaim = () => {
    if (
      get(props.storedClaimToPreopen, 'claim.openingState', null) ===
        OPENING_STATE.NOT_COMPLETED &&
      get(props.storedClaimToPreopen, 'claim.openingType', null) ===
        OPENING_TYPE.USAGE
    ) {
      props.requestCompleteClaim(
        formatClaimToComplete(props, priorityReasonClaimId),
        cleanState,
      );
    } else {
      setIsPreopenSuccessDialogOn(true);
      GATracking.event(GATracking.EVENT_CATEGORIES.CLAIM, 'Lawyer pre-open');
    }
  };

  const handleOpenClaim = () => {
    setOpenConfirmationDialog(true);
  };

  const cleanState = () => {
    props.resetPreopenClaim(EMPTY_CLAIM_TO_PREOPEN);
    props.resetUploadDocumentStore();
    isPreOpeningManager
      ? pushTo(PAGES.PREOPEN_MANAGER_HOME)()
      : pushTo(PAGES.FEE_NOTE)();
  };

  const successCallBackPreOpenClaim = (claimId: number) => {
    props.resetPreopenClaim(EMPTY_CLAIM_TO_PREOPEN);
    props.resetUploadDocumentStore();
    pushTo(`${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/${claimId}`)();
  };

  const cleanStateGpo = () => {
    if (pvHolderType === HOLDER_PV_OTHER) {
      toast.success(translate(messages.otherSuccess, props));
    } else if (pvHolderType === HOLDER_PV_LAWYER) {
      toast.success(
        translate(messages.lawyerSuccess, props, {
          lawyer: get(
            get(props.listings, 'intervenants', []).find(
              (el: any) => el.ItemKey === providerTo,
            ),
            'ItemDescription',
            '',
          ),
        }),
      );
    } else {
      toast.success(translate(messages.providerSuccess, props));
    }
    props.resetPreopenClaim(EMPTY_CLAIM_TO_PREOPEN);
    props.resetUploadDocumentStore();
    pushTo(PAGES.PREOPEN_MANAGER_HOME)();
  };

  const handleClick = () => {
    if (get(props, 'location.state.judicialProcedureId')) {
      return pushTo(PAGES.JUDICIARY_PROCESS, {
        victims: get(formattedClaimToOpen, 'victims', []),
        vehicules: get(formattedClaimToOpen, 'vehicules', []),
        procedureNatureId: get(props, 'location.state.procedureNatureId'),
        procedureType: get(props, 'location.state.procedureType'),
        judicialProcedureId: get(props, 'location.state.judicialProcedureId'),
        claimToPreOpen: getClaimDossier(
          {
            ...props,
            decisionGenerationFeeNote: decisionGenerationFeeNote,
            invoiceInfo: {
              invoiceNumber: invoiceNumber,
              invoiceDate: invoiceDate,
              invoiceReceptionDate: moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceDocument,
            },
            invoiceInfoAdditionelFees: {
              invoiceNumber: invoiceNumberAdditionnelFees,
              invoiceDate:
                invoiceDateAdditionnelFees === 'Invalid date'
                  ? null
                  : invoiceDateAdditionnelFees,
              invoiceReceptionDate: isPreOpeningManager
                ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                  ? moment().format('YYYY-MM-DD')
                  : invoiceReceptionDateAdditionnelFees
                : moment().format('YYYY-MM-DD'),
              isIndexed: false,
              ...invoiceAdditionnelFeesDocument,
            },
          } as any,
          true,
          priorityReasonClaimId,
        ),
      })();
    }
    props.requestPreopenClaim(
      getClaimDossier(
        {
          ...props,
          decisionGenerationFeeNote: decisionGenerationFeeNote,
          invoiceInfo: {
            invoiceNumber: invoiceNumber,
            invoiceDate: invoiceDate,
            invoiceReceptionDate: moment().format('YYYY-MM-DD'),
            isIndexed: false,
            ...invoiceDocument,
          },
          invoiceInfoAdditionelFees: {
            invoiceNumber: invoiceNumberAdditionnelFees,
            invoiceDate:
              invoiceDateAdditionnelFees === 'Invalid date'
                ? null
                : invoiceDateAdditionnelFees,
            invoiceReceptionDate: isPreOpeningManager
              ? invoiceReceptionDateAdditionnelFees === 'Invalid date'
                ? moment().format('YYYY-MM-DD')
                : invoiceReceptionDateAdditionnelFees
              : moment().format('YYYY-MM-DD'),
            isIndexed: false,
            ...invoiceAdditionnelFeesDocument,
          },
        } as any,
        true,
        priorityReasonClaimId,
      ),
      cleanState,
    );
  };

  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };

  const handleClosePreOpenConfirmationDialog = () => {
    setPreOpenConfirmationDialog(false);
  };

  const handlePreOpenDialogClaim = () => {
    if (pvHolderType != HOLDER_PV_OTHER) {
      setOpenProviderService(false);
      props.resetUploadDocumentStore();
      setOpenInvoiceFeeNoteInfoDialog(true);
    } else {
      setOpenProviderService(false);
      setPreOpenConfirmationDialog(true);
    }
  };

  const handleProvideServiceDialog = () => {
    setOpenProviderService(true);
  };

  const successCallBackManager = () => {
    if (featureService.hasFeature(FEATURES.ASSIGNMENT_JURISDICTION_LAWYER)) {
      props.requestNotificationOpeningManagerMixedClaim();
      setOpenConfirmationDialog(false);
      return !featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)
        ? pushTo(PAGES.MANAGER_OPENED_CLAIMS)()
        : pushTo(PAGES.MANAGER_HOME)();
    } else {
      setIsAssignmentDialogOpen(true);
      props.requestNotificationOpeningManagerMixedClaim();
      setOpenConfirmationDialog(false);
    }
  };

  const handleClickManager = () => {
    if (isOpeningManager) {
      if (!isNil(get(props.storedClaimToPreopen, 'claim.lossDate', null))) {
        props.requestOpenClaimManager(
          formatClaimToOpen(
            props.storedClaimToPreopen,
            get(props.policyInfo, 'sagis.claims[0]', {}),
            props.listings,
            get(props.storedClaimToPreopen, 'claim.suspicious'),
            get(props.notification, 'id'),
            priorityReasonClaimId,
          ),
          successCallBackManager,
        );
      } else {
        toast.error(translate({ ...messages.errorInfoClaim }, props));
      }
    } else if (isCourtManager) {
      props.requestMigrateClaim(
        formatClaimToPreOpenCourtManager(
          {
            ...props,
          } as any,
          priorityReasonClaimId,
        ),
        successCallBackPreOpenClaim,
      );
    }
  };

  const isOpeningManager =
    userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
    featureService.hasFeature(FEATURES.OPEN_CLAIM_BY_OPENING_MANAGER);

  const handleOpenInvoicesInfoDialog = () => {
    setIsPreopenSuccessDialogOn(false);
    props.resetUploadDocumentStore();
    setOpenInvoiceFeeNoteInfoDialog(true);
  };

  const handleCloseIsPreopenSuccessDialog = () => {
    setIsPreopenSuccessDialogOn(false);
    doNotGenerateFeeNote();
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    if (isPreOpeningManager) {
      if (featureService.hasFeature(FEATURES.ADD_COST_GPO_OPENING_CLAIM)) {
        setOpenCostsDialog(true);
      } else {
        preOpenClaimManager();
      }
    } else {
      handleClick();
    }
    setOpenInvoiceFeeNoteInfoDialog(false);
  };
  const formattedClaimToOpen = !isNil(
    get(props.storedClaimToPreopen, 'claim', null),
  )
    ? formatClaimToOpen(
        props.storedClaimToPreopen,
        get(props.policyInfo, 'sagis.claims[0]', {}),
        props.listings,
        'NO',
        get(props.notification, 'id'),
        priorityReasonClaimId,
      )
    : {};

  const handleValidatePreOpen = () => {
    preOpenClaimManager();
    setOpenCostsDialog(false);
  };
  return (
    <div>
      <Stepper
        isOpeningManager={isOpeningManager}
        isPreOpeningManager={isPreOpeningManager}
        isCourtManager={userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMANAGER,
        )}
        isBasicManagement={get(props, 'location.state.isFromSagis')}
      />
      <StyledDiv>
        {isOpeningManager
          ? translate({ ...messages.openingManagerrecapPageTitle }, props)
          : translate({ ...messages.recapPageTitle }, props)}
      </StyledDiv>
      <ClaimDeclaration
        isRecapPage
        isManager={false}
        isReadOnly={false}
        updateFilde={() => null}
        inputProps={{ disableUnderline: true }}
        disableInput
        inputLabelProps
        listings={props.listings}
        claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
        storedClaimToPreopen={props.storedClaimToPreopen}
        policyInfo={props.policyInfo}
      />
      <ClaimInformation
        isRecapPage
        isManager={false}
        isReadOnly={false}
        updateFilde={() => null}
        inputProps={{ disableUnderline: true }}
        disableInput
        inputLabelProps
        listings={props.listings}
        claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
        storedClaimToPreopen={props.storedClaimToPreopen}
        stakeholders={[]}
      />
      {featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
        <OpposingPartyRecapContainer
          listings={props.listings}
          claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
          storedClaimToPreopen={props.storedClaimToPreopen}
          policyInfo={props.policyInfo}
          sagisOpposingParties={extractOpposingParties(
            get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
          )}
          isConsultation={
            get(props, 'location.state.isFromSagis') &&
            featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION) &&
            isCourtManager
          }
        />
      )}
      <ClaimCircumstances
        isRecapPage
        isManager={false}
        isReadOnly={false}
        updateFilde={() => null}
        inputProps={{ disableUnderline: true }}
        disableInput
        inputLabelProps
        listings={props.listings}
        claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
        storedClaimToPreopen={props.storedClaimToPreopen}
        claimCircumstancesSagis={get(
          resolveSagisClaim(props.policyInfo),
          'offeredRisks',
          [],
        )?.find(
          (element: { riskName: string }) => element.riskName === rcCoporeal,
        )}
      />
      <VictimCard
        isRecapPage
        isManager={false}
        isReadOnly={false}
        inputProps={{ disableUnderline: true }}
        disableInput
        inputLabelProps
        listings={props.listings}
        claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
        updateFilde={() => null}
        storedClaimToPreopen={props.storedClaimToPreopen}
        isCourtManagerBasicManagement={
          get(props, 'location.state.isFromSagis') &&
          featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION)
        }
      />
      <UploadDocumentsBloc
        storedClaimToPreopen={props.storedClaimToPreopen}
        isManager={false}
        isRecap
        isReadOnly={false}
        requestGetReportsPolicy={() => {}}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        location={get(props, 'location')}
      />
      {featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
        <FraudeInformation
          isRecapPage
          disableInput
          updateFilde={() => null}
          claimToPreopen={EMPTY_CLAIM_TO_PREOPEN}
          storedClaimToPreopen={props.storedClaimToPreopen}
          policyInfo={props.policyInfo}
          listings={props.listings}
          isPreOpening
        />
      )}
      <NavigationButtons
        isRecap={
          get(props, 'location.state.isFromSagis') &&
          (featureService.hasFeature(FEATURES.BASIC_MANAGEMENT) ||
            featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION))
            ? get(props, 'location.state.judicialProcedureId')
              ? false
              : true
            : true
        }
        onPreviousClick={
          isOpeningManager
            ? pushTo(PAGES.UPLOAD_DOCUMENTS_MANAGER)
            : isPreOpeningManager
            ? pushTo(PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER, {
                isUsageOpening: isUsageOpening,
              })
            : !get(props, 'location.state.isFromSagis') ||
              !(
                featureService.hasFeature(FEATURES.BASIC_MANAGEMENT) ||
                featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION)
              )
            ? pushTo(PAGES.UPLOAD_DOCUMENTS)
            : isCourtManager
            ? pushTo(PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS, {
                isFromSagis: true,
                sagisInfoClaim: get(props, 'location.state.sagisInfoClaim'),
              })
            : pushTo(PAGES.UPLOAD_DOCUMENTS, {
                isFromSagis: true,
                procedureNatureId: get(
                  props,
                  'location.state.procedureNatureId',
                ),
                procedureType: get(props, 'location.state.procedureType'),
                judicialProcedureId: get(
                  props,
                  'location.state.judicialProcedureId',
                ),
              })
        }
        forwardClick={
          isOpeningManager || isCourtManager
            ? handleOpenClaim
            : isPreOpeningManager && !isUsageOpening
            ? handleProvideServiceDialog
            : isPreOpeningManager && isUsageOpening && isValidatedClaim
            ? handleProvideServiceDialog
            : isPreOpeningManager && isUsageOpening && !isValidatedClaim
            ? preOpenClaimManager
            : handlePreopenClaim
        }
      />
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) ? (
        <InvoiceFeeNoteDialog
          open={isPreopenSuccessDialogOn}
          onClose={setIsPreopenSuccessDialogOn}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : handleCloseIsPreopenSuccessDialog
          }
          shouldDisplayFirmReferenceField={false}
          setLawyerFirmRef={setLawyerFirmRef}
          lawyerFirmRef={lawyerFirmRef}
        />
      ) : (
        <SuccessDialog
          title={translate({ ...messages.successDialogMessage }, props)}
          secondaryButtonTitle={translate(
            { ...messages.successDialogGoBackToHomePage },
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE)
              ? translate({ ...messages.successButtonFeeNote }, props)
              : translate({ ...messages.successDialogGoBackToHomePage }, props)
          }
          onPrimaryClick={handleClick}
          tertiaryButtonTitle={translate(
            { ...messages.doNotGenerateFeeNote },
            props,
          )}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isPreopenSuccessDialogOn}
          onClose={setIsPreopenSuccessDialogOn}
          homePath={PAGES.LAWYER_HOME}
          isExpertReport={false}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          invoiceReceptionDate={invoiceReceptionDate}
          setInvoiceReceptionDate={setInvoiceReceptionDate}
          isManager={isPreOpeningManager}
          claimReceptionDate={isPreOpeningManager ? receptionDate : undefined}
          fillReceptionDate={pvHolderType === HOLDER_PV_PROVIDER ? true : false}
          pvHolder={pvHolderType}
          limitInvoiceDate={
            isPreOpeningManager
              ? getLimitInvoiceManager(get(props.listings, 'appConfig', []))
              : getLimitInvoiceIntervenant(get(props.listings, 'appConfig', []))
          }
        />
      )}
      {openConfirmationDialog && (
        <Dialog
          open={openConfirmationDialog}
          handleClose={handleCloseConfirmationDialog}
          handleValidate={handleClickManager}
          title={translate(
            messages.openingManagerConfirmationDialogTitle,
            props,
          )}
          confirmTitle={translate(
            messages.openingManagerConfirmationDialogConfirm,
            props,
          )}
          cancelTitle={translate(
            messages.openingManagerConfirmationDialogCancel,
            props,
          )}
        >
          <div className="content">
            {translate(
              renderDescriptionDialog(isOpeningManager, isCourtManager)
                ?.description,
              props,
            )}
          </div>
          <div className="info-message">
            {translate(
              renderDescriptionDialog(isOpeningManager, isCourtManager)
                ?.subDescription,
              props,
            )}
          </div>
        </Dialog>
      )}
      {preOpenConfirmationDialog && (
        <Dialog
          open={preOpenConfirmationDialog}
          handleClose={handleClosePreOpenConfirmationDialog}
          handleValidate={preOpenClaimManager}
          title={translate(
            messages.preopeningManagerConfirmationDialogTitle,
            props,
          )}
          confirmTitle={translate(
            messages.preopeningManagerConfirmationDialogConfirm,
            props,
          )}
          cancelTitle={translate(
            messages.preopeningManagerConfirmationDialogCancel,
            props,
          )}
        >
          <div className="content">
            {translate(
              messages.preopeningManagerConfirmationDialogDescription,
              props,
            )}
          </div>
          <div className="info-message">
            {translate(
              messages.preopeningManagerConfirmationDialogSubDescription,
              props,
            )}
          </div>
        </Dialog>
      )}
      {isAssignmentDialogOpen && (
        <AssignmentDialog
          open={isAssignmentDialogOpen}
          onClose={handleCloseAssignmentDialog}
          subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
          zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
          services={get(props.listings, LISTINGS.SERVICES, [])}
          stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
          stackholderTypes={get(props.listings, LISTINGS.STACKHOLDER_TYPE, [])}
          requestAssigment={props.requestAssigment}
          claim={props.storedClaimToPreopen.claim}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={props.corporealLawyers}
          shouldAssignOnSagis={false}
          isManagerOpenedClaimsPage={false}
          listings={props.listings}
          claimNumber={get(props.storedClaimToPreopen.claim, 'claimNumber')}
          isOpeningManager={true}
          isClaim
        />
      )}
      {openProviderService && (
        <ServiceProviderDialog
          open={openProviderService}
          onClose={handleCloseProvider}
          providers={props.intervenants?.filter(
            (el: any) => el.ItemType === '104',
          )}
          providerTo={providerTo}
          setProviderTo={setProviderTo}
          ConfirmAction={handlePreOpenDialogClaim}
          completionDate={completionDate}
          setCompletionDate={setCompletionDate}
          receptionDate={receptionDate}
          setReceptionDate={setReceptionDate}
          lossDate={get(props.storedClaimToPreopen, 'claim.lossDate')}
          listings={props.listings}
          pvHolderType={pvHolderType}
          setPvHolderType={setPvHolderType}
          otherPvHolder={otherPvHolder}
          setOtherPvHolder={setOtherPvHolder}
          stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
          stackholderTypes={get(props.listings, LISTINGS.STACKHOLDER_TYPE, [])}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={props.corporealLawyers}
          firmReferenceLawyer={firmReferenceLawyer}
          setFirmReferenceLawyer={setFirmReferenceLawyer}
        />
      )}
      {openCostsDialog && (
        <CostsDialog
          uploadedDocument={props.uploadedDocument}
          open={openCostsDialog}
          onClose={() => {
            setOpenCostsDialog(false);
          }}
          ConfirmAction={handleValidatePreOpen}
          handleChangeCosts={setCost}
          document={documentCosts}
          setDocument={setDocumentCosts}
          resetUploadedDocument={props.resetUploadDocumentStore}
          cost={cost}
          decisionCosts={decisionCosts}
          setDecisionCosts={setDecisionCosts}
          uploadDocument={props.uploadDocument}
          setDocumentId={props.setDocumentId}
          setInvoiceReceptionDateAdditionnelFees={
            setInvoiceReceptionDateAdditionnelFees
          }
          invoiceReceptionDateAdditionnelFees={
            invoiceReceptionDateAdditionnelFees
          }
          claimReceptionDate={isPreOpeningManager ? receptionDate : undefined}
          fillReceptionDate={pvHolderType === HOLDER_PV_PROVIDER ? true : false}
          invoiceAdditionnelFeesDocument={invoiceAdditionnelFeesDocument}
          setInvoiceAdditionnelFeesDocument={setInvoiceAdditionnelFeesDocument}
          invoiceNumberAdditionnelFees={invoiceNumberAdditionnelFees}
          setInvoiceNumberAdditionnelFees={setInvoiceNumberAdditionnelFees}
          invoiceDateAdditionnelFees={invoiceDateAdditionnelFees}
          setInvoiceDateAdditionnelFees={setInvoiceDateAdditionnelFees}
          limitInvoiceDate={getLimitInvoiceManager(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = {
  requestPreopenClaim,
  resetPreopenClaim,
  requestCorporealLawyers,
  resetUploadDocumentStore,
  requestOpenClaimManager,
  requestNotificationOpeningManagerMixedClaim,
  requestAssigment,
  uploadDocument,
  requestOpenClaimGpo,
  setDocumentId,
  requestMigrateClaim,
  requestGetDocByDocumentumId,
  requestCompleteClaim,
  requestValidateCompleteClaim,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  storedClaimToPreopen: makeSelecClaimToPreopen(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  corporealLawyers: makeSelectCorporealLawyers(),
  notification: makeSelectNotification(),
  intervenants: makeSelectListingsIntervenants(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RecapPage));
